import * as scopes from '../state/scopes';
export const mutations = {
  init: ({
    state
  }) => _ => {
    return state;
  },
  edit: ({
    id,
    changes
  }) => state => {
    const existing = state.template.index[id];
    return {
      ...state,
      template: {
        ...state.template,
        index: {
          ...state.template.index,
          [existing.id]: {
            ...existing,
            ...changes
          }
        }
      }
    };
  },
  add: ({
    template,
    scopes = {}
  }) => state => {
    return {
      ...state,
      template: {
        ...state.template,
        index: {
          ...state.template.index,
          [template.id]: template
        }
      },
      scope: {
        ...state.scope,
        index: {
          ...state.scope.index,
          ...scopes
        }
      }
    };
  },
  import: ({
    templates,
    scopes
  }) => state => {
    return {
      ...state,
      scope: {
        ...state.scope,
        index: {
          ...state.scope.index,
          ...scopes
        }
      },
      template: {
        ...state.template,
        index: {
          ...state.template.index,
          ...templates
        }
      }
    };
  },
  delete: ({
    id
  }) => state => {
    const truncated = {
      ...state.template.index
    };
    delete truncated[id];
    return {
      ...state,
      template: {
        ...state.template,
        index: truncated
      }
    };
  },
  document: {
    attachSampleReport: ({
      templateId,
      attachment
    }) => state => {
      return {
        ...state,
        template: {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...state.template.index[templateId],
              sampleReport: attachment
            }
          }
        }
      };
    },
    attachReportTemplate: ({
      templateId,
      attachment
    }) => state => {
      return {
        ...state,
        template: {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...state.template.index[templateId],
              reportTemplate: attachment
            }
          }
        }
      };
    },
    removeSampleReport: ({
      templateId
    }) => state => {
      const truncated = {
        ...state.template.index[templateId]
      };
      delete truncated['sampleReport'];
      return {
        ...state,
        template: {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...truncated
            }
          }
        }
      };
    },
    removeReportTemplate: ({
      templateId
    }) => state => {
      const truncated = {
        ...state.template.index[templateId]
      };
      delete truncated['reportTemplate'];
      return {
        ...state,
        template: {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...truncated
            }
          }
        }
      };
    }
  },
  scope: {
    add: ({
      templateId,
      scope
    }) => state => {
      const template = {
        ...state.template,
        index: {
          ...state.template.index,
          [templateId]: {
            ...state.template.index[templateId],
            scopes: [...state.template.index[templateId].scopes, scope.id]
          }
        }
      };
      return {
        ...state,
        scope: scopes.mutations.add({
          scope
        })(state.scope),
        template
      };
    },
    delete: ({
      scopeId,
      templateId
    }) => state => {
      const id = scopeId;
      const template = {
        ...state.template,
        index: {
          ...state.template.index,
          [templateId]: {
            ...state.template.index[templateId],
            scopes: state.template.index[templateId].scopes.filter(s => s !== id)
          }
        }
      };
      return {
        ...state,
        scope: scopes.mutations.delete({
          scopeId
        })(state.scope),
        template
      };
    },
    import: ({
      templateId,
      scopes
    }) => state => {
      const scopeIds = Object.keys(scopes);
      return {
        ...state,
        scope: {
          ...state.scope,
          index: {
            ...state.scope.index,
            ...scopes
          }
        },
        template: {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...state.template.index[templateId],
              scopes: [...state.template.index[templateId].scopes, ...scopeIds]
            }
          }
        }
      };
    },
    reorder: ({
      templateId,
      scopeIds
    }) => state => {
      let template = state.template;
      if (templateId) {
        template = {
          ...state.template,
          index: {
            ...state.template.index,
            [templateId]: {
              ...state.template.index[templateId],
              scopes: scopeIds
            }
          }
        };
      }
      return {
        ...state,
        template
      };
    },
    edit: scopes.mutations.edit
  }
};
export const initialState = () => ({
  template: {
    index: {}
  },
  scope: scopes.initialState(),
  organizations: {},
  jurisdictions: [],
  subjectTypes: []
});